module.exports = __webpack_public_path__ + "img/web-browser.2bf94f76.svg";